// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { Autocomplete } from "stimulus-autocomplete"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FormController from "./form_controller.js"
application.register("form", FormController)

import SwalController from "./swal_controller.js"
application.register("swal", SwalController)

import DatePickerController from "./datepicker_controller.js"
application.register("datepicker", DatePickerController)

import TableFiltersController from "./table_filters_controller.js"
application.register("table-filters", TableFiltersController)

import TableExportController from "./table_export_controller.js"
application.register("table-export", TableExportController)

application.register("autocomplete", Autocomplete)

import AutocompletclickoutController from "./autocompleteclickout_controller.js"
application.register("autocompleteclickout", AutocompletclickoutController)

import TownsSuggestionsController from "./towns_suggestions_controller.js"
application.register("towns-suggestions", TownsSuggestionsController)